<script lang="ts">
  // The shell's first Tab stop while a sign-in waits for an answer (B27): hidden until focused,
  // Enter moves focus to the banner's buttons. Native link, no tabindex.
  import { focusSecurityBanner, securityBannerPresence } from "$lib/security-banner-presence.svelte.js";
</script>

{#if securityBannerPresence.open}
  <a
    href="#security-banner-line"
    data-security-banner-skip
    class="sr-only rounded px-2.5 py-0.5 text-sm font-semibold focus:not-sr-only focus:absolute focus:left-[calc(var(--titlebar-traffic-light-inset)+0.5rem)] focus:top-2 focus:z-[var(--z-dialog)]"
    style="background-color: var(--btn-primary-bg); color: var(--btn-primary-text); -webkit-app-region: no-drag;"
    onclick={(e) => {
      e.preventDefault();
      focusSecurityBanner();
    }}
  >
    Review new sign-in
  </a>
{/if}
